import { notification } from "antd";
import "antd/lib/notification/style/index.css";
import "./style.css";

type Type = 'info' | 'success' | 'warning' | 'error';

const notice = (type: Type, title: any, message = "", duration: null | number = null) => {
  notification[type]({
    message: title,
    description: message,
    placement: "bottomLeft",
    duration: (type === 'success' && !duration) ? 5 : duration,
  });
};

export default notice;
